<!--
 * @Author: ljc_625738144@qq.com
 * @Date: 2024-08-13 14:15:36
 * @LastEditors: ljc_625738144@qq.com
 * @LastEditTime: 2024-08-21 10:13:45
 * @Description: 导出提示框
 * @FilePath: \haozhang_pro\src\pages\pageInvoice\generateTip.vue
-->
<template>
  <BaseDialog
    title = "提示"
    :showVisible = "isShow"
    @close = "isShow = false"
    @confirm = "confirm"
  >
    <template v-slot:content>
      <div>{{ `当操作仅对未生成凭证的 ${ noGenerateList.length } 条数据生效，已生成凭证的数据自动跳过。 ` }}</div>
    </template>
  </BaseDialog>
</template>
<script>
import BaseDialog from '@/components/dialog/BaseDialog.vue';
export default {
  props: {
    showVisible: {
      type: Boolean,
      default: false
    },
    ListData: {
      type: Array,
      default: () => []
    }
  },
  components: {
    BaseDialog
  },
  computed: {
    isShow: {
      get() {
        return this.showVisible;
      },
      set(val) {
        this.$emit('update:showVisible', val);
      }
    },
    noGenerateList() {
      return this.ListData.filter(i=> !i.vocherChiefWordNumber);
    }
  },
  data() {
    return {
    };
  },
  methods: {
    confirm() {
      this.$emit('confirm',this.noGenerateList);
      this.isShow = false;
    }
  }
};
</script>
<style lang="less">

</style>



// WEBPACK FOOTER //
// src/pages/pageInvoice/generateTip.vue